import CategoryLabel from '../enum/CategoryLabel';

const initWithStockDisabledCategories = [CategoryLabel.COLOUR, CategoryLabel.INTERIOR, CategoryLabel.EXTERIOR];

export default initWithStockDisabledCategories;
